import { Outlet, Link, useLocation } from 'react-router-dom'
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Box, 
  Container,
  Tabs,
  Tab
} from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import lotteryTheme from './theme'

function App() {
  const location = useLocation()
  
  const getTabValue = () => {
    switch (location.pathname) {
      case '/fast3':
        return 0
      case '/profile':
        return 1
      default:
        return 0
    }
  }

  // 判斷是否為全屏頁面（FastThree 和 Profile 頁面使用自己的導航）
  const isFullScreenPage = location.pathname === '/fast3' || location.pathname === '/profile'
  
  if (isFullScreenPage) {
    return (
      <ThemeProvider theme={lotteryTheme}>
        <CssBaseline />
        <Outlet />
      </ThemeProvider>
    )
  }

  return (
    <ThemeProvider theme={lotteryTheme}>
      <CssBaseline />
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <AppBar position="static">
          <Toolbar>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              🎲 幸運彩票網站
            </Typography>
          </Toolbar>
        </AppBar>
        
        <Container maxWidth="lg" sx={{ mt: 2 }}>
          <Tabs value={getTabValue()} sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
            <Tab label="🎲 快三遊戲" component={Link} to="/fast3" />
            <Tab label="👤 個人中心" component={Link} to="/profile" />
          </Tabs>
        </Container>
        
        <Box component="main" sx={{ flexGrow: 1 }}>
          <Outlet />
        </Box>
      </Box>
    </ThemeProvider>
  )
}

export default App
